/**
 * Created by ZXW on 2018/3/1.
 */
import { Message } from 'element-ui'
import JSEncrypt from 'jsencrypt'
function full0 (val) {
  if (val < 10) {
    return '0' + val
  } else {
    return val
  }
}
export default {
  checkUrl: (value) => {
    if (!value) {
      Message.error('请输入H5地址')
      return false
    }
    var reg = new RegExp(/^((ht|f)tps?):\/\/[\w\-]+(\.[\w\-]+)+([\w\-\.,@?^=%&:\/~\+#]*[\w\-\@?^=%&\/~\+#])?$/)
    if (!reg.test(value)) {
      Message.error('地址需以http或https开头')
      return false
    }
    return true
  },
  $encyptKey: (str) => {
    let jse = new JSEncrypt()
    let key = localStorage.getItem('publickey')
    jse.setPublicKey(key)
    let result = jse.encrypt(str)
    return result
  },
  $encode64: (input) => {
    let keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '='
    let output = ''
    let chr1
    let chr2
    let chr3
    let enc1
    let enc2
    let enc3
    let enc4
    let i = 0
    do {
      chr1 = input.charCodeAt(i++)
      chr2 = input.charCodeAt(i++)
      chr3 = input.charCodeAt(i++)
      enc1 = chr1 >> 2
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4)
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6)
      enc4 = chr3 & 63
      if (isNaN(chr2)) {
        enc3 = enc4 = 64
      } else if (isNaN(chr3)) {
        enc4 = 64
      }
      output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4)
      chr1 = chr2 = chr3 = ''
      enc1 = enc2 = enc3 = enc4 = ''
    } while (i < input.length)

    return output
  },

  checkPassword (val) {
    /* 返回密码的强度级别 */
    function checkStrong (sPW) {
      if (sPW.length < 8) {
        return 0 // 密码太短
      }
      let Modes = 0
      for (let i = 0; i < sPW.length; i++) {
        // 测试每一个字符的类别并统计一共有多少种模式.
        Modes |= CharMode(sPW.charCodeAt(i))
      }
      return bitTotal(Modes)
    }
    /* 判断字符类型 */
    function CharMode (iN) {
      if (iN >= 48 && iN <= 57) { // 数字
        return 1
      } else if ((iN >= 65 && iN <= 90) || (iN >= 97 && iN <= 122)) { // 大小写字母
        return 2
      } else {
        return 0 // 特殊字符
      }
    }
    /* 统计字符类型 */
    function bitTotal (num) {
      let modes = 0
      for (let i = 0; i < 4; i++) {
        if (num & 1) modes++
        num >>>= 1
      }
      return modes
    }
    /**
     * 密码强度等级说明，字符包括：小写字母、大写字母、数字、特殊字符
     * 1---密码包含其中之一
     * 2---密码包含其中之二
     * 3---密码包含其中之三
     * 4---密码包含其中之四
    */
    if (checkStrong(val) < 2) {
      return false
    }
    return true
  },
  checkEdit: (value) => {
    if (!value) {
      Message.error('请输入软文配置内容')
      return false
    }
    return true
  },
  checkPhone: (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入联系电话'))
    }
    setTimeout(() => {
      var reg = new RegExp(/^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/)
      if (!reg.test(value)) {
        callback(new Error('联系电话不符合规则'))
      } else {
        callback()
      }
    }, 1000)
  },
  checkEmail: (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入邮箱'))
    }
    setTimeout(() => {
      var reg = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
      if (!reg.test(value)) {
        callback(new Error('邮箱不符合规则'))
      } else {
        callback()
      }
    }, 1000)
  },
  checkPwd: (rule, value, callback) => {
    if (!value) {
      return callback(new Error('请输入密码'))
    }
    setTimeout(() => {
      var reg = /^[a-zA-Z\d_]{6,}$/
      if (!reg.test(value)) {
        callback(new Error('密码为6位以上(含6位)的数字、字母或下划线组成'))
      } else {
        callback()
      }
    }, 1000)
  },
  formatTime: (val) => {
    var time = new Date(val)
    var y = time.getFullYear()
    var m = full0(time.getMonth() + 1)
    var d = full0(time.getDate())
    var h = full0(time.getHours())
    var s = full0(time.getMinutes())
    var miao = full0(time.getSeconds())
    return y + '-' + m + '-' + d + ' ' + h + ':' + s + ':' + miao
  }
}



// WEBPACK FOOTER //
// ./src/js/fun.js